export const API_HOST = process.env.NODE_ENV === "production" ? "https://api.surgtrac.com" : "http://localhost:8003";
export const WEBHOOK_HOST = "https://webhook.surgtrac.com";
